<template>
  <v-card>
    <v-card-title class="headline">
      <v-icon>check</v-icon>
      Aprobar Movilidad
      <v-spacer />
      <v-btn icon @click="close()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
    <v-container
      grid-list-md
    >
      <v-layout wrap>
        <v-flex md12>
          <strong>Tipo de movilidad:</strong> {{ movilidad.tipo_movimiento }}
        </v-flex>
        <v-flex md12>
          <strong>Funcionario:</strong> {{ movilidad.funcionario.nombre }}
        </v-flex>
        <v-flex md6>
          <strong>Item:</strong> {{ movilidad.nro_item }}
        </v-flex>
        <v-flex md6>
          <strong>Fecha desde:</strong> {{ movilidad.fecha_desde }}
        </v-flex>
      </v-layout>
    </v-container>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn
      color="success"
      :loading="loading"
      @click="aprobarRechazar(1)"
    >
      <v-icon>check</v-icon> Aprobar
    </v-btn>
    <v-btn
      color="error"
      :loading="loading"
      @click="aprobarRechazar(0)"
    >
      <v-icon>clear</v-icon> Rechazar
    </v-btn>
  </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['movilidad'],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    close () {
      this.$bus.$emit('closeDialogAprobar')
    },
    async aprobarRechazar (tipo) {
      try {
        this.loading = true
        let user = this.$storage.get('user')
        let temp = this.$moment(this.movilidad.fecha_desde, 'DD/MM/YYYY').format('YYYY-MM-DD')
        let res = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta: "SELECT movilidad.fn_aprueba_rechaza_movilidad(${this.movilidad.funcionario.id_persona}, ${user.id}, ${tipo}, '${temp}',${this.form.nro_memorandum},${this.form.fecha_memorandum},null,null)"){
                respuesta
              }
            }
          `
        })
        if (res.runQuery.respuesta[0].fn_aprueba_rechaza_movilidad === 1) {
          this.$message.success()
          location.reload()
        } else {
          this.$message.error()
        }
        this.loading = false
        this.close()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/persona/components/AprobarCambioItem.vue